import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconStaticReminderCard = function IconStaticReminderCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 44"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    fillRule: "evenodd",
    d: "M6 37.001a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2H7v1a1 1 0 1 1-2 0v-1H4a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    d: "M6 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2M1 34a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    fillRule: "evenodd",
    d: "M36 0a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0V4h-1a1 1 0 1 1 0-2h1V1a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    d: "M39 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F1F3",
    d: "m20.154 7.017-11.172 7.4 12.274-3.288z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m9.039 14.628 17.386-4.66L32.12 31.22l-17.387 4.658z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    d: "m9.039 14.628 17.386-4.66L32.12 31.22l-17.387 4.658z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    fillRule: "evenodd",
    d: "M21.12 6.759a1 1 0 0 0-1.518-.575L8.43 13.585a1 1 0 0 0-.395 1.156l.015.065 1.172 4.37a.999.999 0 1 0 1.931-.518l-.912-3.404 15.455-4.142 5.199 19.401-15.455 4.142-1.56-5.82a1 1 0 1 0-1.931.518l1.818 6.785a1 1 0 0 0 1.224.707l17.388-4.659a1 1 0 0 0 .706-1.224L27.369 9.629a1 1 0 0 0-1.224-.706l-4.148 1.11-.878-3.274zm-1.09 3.664-5.384 1.442 4.901-3.246z",
    clipRule: "evenodd"
  }));
};